.kdx-site-search {
  position: relative;
  overflow: hidden;
  padding: 0 0 2px;

  &.input-group {
    > .form-control {
      margin: 0;

      &:focus,
      &:active {
        z-index: auto; // Bootstrap override
      }
    }

  }

  .input-group-text {
    background-color: #fff;
    border: none;
    border-radius: 0;
  }

  > .form-control {
    border: none;
    border-radius: 0;
    @include text-size(15);
    color: $senary;
    max-height: 25px;
    padding: 0;

    + .input-group-text {
      padding: 0;
    }

    &::placeholder {
      color: $senary;
      @include text-size(15);
    }

    &:active,
    &:focus {
      border: none;
      outline: none;
      box-shadow: none;
    }
  }

  .svg-icon {
    svg {
      @include svg-format(20px, 20px, $primary);
    }
  }

  &:before,
  &:after {
    // content: '';
    position: absolute;
    display: block;
    width: 100%;
    height: 1px;
    background-color: $senary;
    bottom: 0;
    left: 0;
    z-index: 1;
    transform: translateX(0);
    @include transitionDefault(transform);
  }

  &:before {
    background-color: $primary;
    transform: translateX(-100%);
    @include transitionDefault(transform);
  }

  &.has-focus {
    &:before,
    &:after {
      transform: translateX(100%);
      @include transitionDefault(transform);
    }

    &:before {
      box-shadow: 0px 0px 6px rgba(111, 178, 229, 1);
      transform: translateX(0);
    }
  }

  @include media-breakpoint-down(lg) {
    flex-wrap: nowrap;

    input[type="text"] {
      padding: 10px;
      height: auto;
      max-height: none;
    }

    button[type="submit"] {
      width: auto;
      padding-right: 10px !important;
    }
  }
}
